import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Grid, Typography, MenuItem } from "@material-ui/core";
import { Field, formValueSelector } from "redux-form/immutable";

import { required } from "utils/validation.util";
import TextField from "app/components/form/TextField";
import CheckboxField from "app/components/form/CheckboxField";
import { COMPANY_FORM } from "features/planner/planner.constants";
import { getCountriesFromState } from "features/planner/planner.selectors";
import SpecificationLinkField from "features/planner/components/SpecificationLinkField";

const CompanyForm = ({ handleSubmit, countries }) => (
  <form onSubmit={handleSubmit} id={COMPANY_FORM.ID}>
    <Grid container direction="column">
      <Grid item container spacing={2}>
        <Grid item container />
        <Grid item container>
          <Field
            name={COMPANY_FORM.SPECIFICATION}
            component={SpecificationLinkField}
          >
            Manage company requirements
          </Field>
        </Grid>
        <Grid item xs container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="h6">Company Details</Typography>
          </Grid>
          <Grid item>
            <Field
              required
              autoFocus
              fullWidth
              margin="none"
              label="Name"
              validate={[required]}
              component={TextField}
              name={COMPANY_FORM.NAME}
            />
          </Grid>
          <Grid item>
            <Field
              select
              required
              fullWidth
              margin="none"
              label="Country"
              validate={[required]}
              component={TextField}
              name={COMPANY_FORM.COUNTRY}
            >
              {countries.map(country => (
                <MenuItem key={country.get("id")} value={country.get("id")}>
                  {country.get("name")}
                </MenuItem>
              ))}
            </Field>
          </Grid>
          <Grid item>
            <Field
              label="Company is a customer"
              component={CheckboxField}
              name={COMPANY_FORM.IS_CUSTOMER}
            />
          </Grid>
          <Grid item>
            <Field
              label="Company is a supplier"
              component={CheckboxField}
              name={COMPANY_FORM.IS_SUPPLIER}
            />
          </Grid>
        </Grid>
        <Grid item xs container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="h6">Contact Details</Typography>
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={6}>
              <Field
                fullWidth
                margin="none"
                label="Contact Name"
                component={TextField}
                name={COMPANY_FORM.CONTACT_NAME}
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                fullWidth
                margin="none"
                label="Contact Phone"
                component={TextField}
                name={COMPANY_FORM.CONTACT_PHONE}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={6}>
              <Field
                fullWidth
                margin="none"
                label="Contact Email"
                component={TextField}
                name={COMPANY_FORM.CONTACT_EMAIL}
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                fullWidth
                margin="none"
                label="Contact Mobile"
                component={TextField}
                name={COMPANY_FORM.CONTACT_MOBILE}
              />
            </Grid>
          </Grid>
          <Grid item>
            <Field
              fullWidth
              margin="none"
              label="Notes"
              multiline
              rows={3}
              rowsMax={15}
              component={TextField}
              name={COMPANY_FORM.NOTES}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </form>
);

const companyFormValueSelector = formValueSelector(COMPANY_FORM.ID);

export default compose(
  connect(state => ({
    countries: getCountriesFromState(state),
    isCustomer: companyFormValueSelector(state, COMPANY_FORM.IS_CUSTOMER),
  })),
)(CompanyForm);
